import { instanceCore } from './instances.ts';
import { AuthApi } from './auth-api.ts';
import { PartnersApi } from './partners-api.ts';
import { CommonApi } from './common-api.ts';
import { CoursesApi } from './courses-api.ts';
import { UsersApi } from './users-api.ts';
import { PlayersApi } from './players-api.ts';
import { DevicesApi } from './devices-api.ts';
import { IGolfApi } from './iGolf-api.ts';

const authApi = new AuthApi(instanceCore);
const partnersApi = new PartnersApi(instanceCore);
const commonApi = new CommonApi(instanceCore);
const coursesApi = new CoursesApi(instanceCore);
const usersApi = new UsersApi(instanceCore);
const playersApi = new PlayersApi(instanceCore);
const devicesApi = new DevicesApi(instanceCore);
const iGolfApi = new IGolfApi(instanceCore);
export const API = {
  auth: authApi,
  partners: partnersApi,
  common: commonApi,
  courses: coursesApi,
  users: usersApi,
  players: playersApi,
  devices: devicesApi,
  iGolf: iGolfApi,
};
